<script lang="ts">
    import type { Price } from '@shared/types/types';

    interface Props {
        price: Price;
    }

    let { price }: Props = $props();
</script>

{#if price.sale && price.suggestedRetailPrice}
    <span class="oc-copy-75"
        >UVP <span class={['reptile-price__priceValue', 'reptile-price__priceValue--strikethrough']}
            >{price.suggestedRetailPrice} €</span
        ></span
    >
{:else if price.sale && price.comparativePrice}
    <span class={['reptile-price__priceValue', 'reptile-price__priceValue--strikethrough', 'oc-copy-75']}
        >{price.comparativePrice} €</span
    >
{/if}

<style lang="scss">
    .reptile-price {
        &__priceValue {
            white-space: nowrap;

            &--strikethrough {
                text-decoration: line-through;
            }
        }
    }
</style>
